import { Input as antdInput, InputNumberProps, Form, InputProps } from 'antd';
import { FormItemProps } from '@ant-design/compatible/lib/form';
import styled from 'styled-components';

import { InputLabelWithTooltip } from 'common/components/form/components/InputLabelWithTooltip';
import { FormInputProps } from 'common/components/form/models';
import { NamePath } from 'antd/lib/form/interface';

const StyledFormItem = styled(Form.Item)<{ nobottommargin: number }>(
    ({ nobottommargin }) => `
        margin-bottom: ${nobottommargin ? 0 : '1rem'};
`,
);

const InputWrapper = styled(antdInput)`
    width: 100%;
`;

type Props = FormItemProps &
    Omit<InputProps, 'name'> &
    FormInputProps & {
        validateDecimals?: boolean;
        name: NamePath;
        noBottomMargin?: boolean;
    };

export const Input = ({
    name,
    placeholder,
    label,
    required = true,
    requiredMessage,
    disabled = false,
    hidden,
    autoComplete,
    tooltip,
    help,
    value,
    type,
    validateStatus,
    noBottomMargin,
    onChange,
    readOnly = false,
}: Props) => (
    <StyledFormItem
        name={name}
        label={
            tooltip ? (
                <InputLabelWithTooltip label={label || placeholder} tooltip={tooltip} />
            ) : (
                label || placeholder
            )
        }
        help={help}
        validateStatus={validateStatus}
        rules={[{ required, message: requiredMessage || `${label || placeholder} is required` }]}
        hidden={hidden}
        nobottommargin={noBottomMargin ? 1 : 0}
        labelCol={{ span: 24 }}
    >
        <InputWrapper
            size="large"
            type={type}
            value={value}
            placeholder={placeholder || label}
            disabled={disabled}
            hidden={hidden}
            autoComplete={autoComplete}
            onChange={onChange}
            readOnly={readOnly}
        />
    </StyledFormItem>
);
